export const labels = {
	dontAskAgain: {
		label: "Label.MobileCreator.DontAskAgain",
		default: "Don't ask again",
	},
} as const;
